import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/SiteShell";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/ambassadors/join-terms")({
  head: () => ({
    meta: [
      { title: DICTS.en["upjoin.terms.title"] },
      { name: "description", content: DICTS.en["upjoin.terms.p1"] },
      { property: "og:title", content: DICTS.en["upjoin.terms.title"] },
      { property: "og:description", content: DICTS.en["upjoin.terms.p1"] },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: JoinTerms,
});

function JoinTerms() {
  const { t, dir } = useLocale();
  return (
    <SiteShell>
      <article className="mx-auto max-w-2xl px-4 py-14 space-y-4" dir={dir}>
        <h1 className="t-h2 text-foreground">{t("upjoin.terms.title")}</h1>
        {["p1", "p2", "p3", "p4"].map((k) => (
          <p key={k} className="text-sm text-muted-foreground leading-relaxed">{t(`upjoin.terms.${k}`)}</p>
        ))}
      </article>
    </SiteShell>
  );
}
